// extracted by mini-css-extract-plugin
export default {"tabela_licitacao":"tabela_ordinances_tabela_licitacao__53a8y","btn_download":"tabela_ordinances_btn_download__9Zp0N"};